import { AxiosResponse } from 'axios';
import { client } from "../../../shared/services/client";
import { CarrierAddress } from '../Model/CarrierAddresses';
import { CompanyCommissionRateDto } from '../Model/CompanyCommissionRate';
import { CompanyRetentionRateDto, CreateCompanyRetentionRateDto, UpdateCompanyRetentionRateDto } from '../Model/CompanyRetentionRate';
import { AdvPlusRatingCompanyDto } from '../Model/AdvPlusRatingCompany';
const carrierBaseKey = "carrierManagement";
const retentionArrayBaseKey = "retentionArray";

export default class CarrierManagementAPI {

    getCarriers = async (): Promise<any[]> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<any[]> = await client.get<any[]>("api/company");
        return res.data;
    };

    getCarrierById = async (id: string): Promise<any> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<any> = await client.get<any>(`api/company/${id}`);

        const data = res.data;
        return {
            id: data.id,
            name: data.name,
            type: data.type,
            status: data.status,
            naic: data.naic,
            ibmAddress: data.ibmAddress,
            parentCompanyId: data.parentCompanyId,
            parentCompanyName: data.parentCompanyName,
            companyType: data.companyType,
            isActive: data.isActive,
            carrierAddress: data.addresses,
            ivansSenderBoxAddresses : data.ivansSenderBoxAddresses,
            informalSenderName : data.informalSenderName
        };
    };

    createCarrier = async (carrier: any): Promise<any> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<any> = await client.post("api/company", carrier);
        return res.data;
    };

    updateCarrier = async (carrier: any): Promise<any> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<any> = await client.put(`api/company/${carrier.id}`, carrier);
        return res.data;
    }

    getCommissionRates = async (companyId: string): Promise<CompanyCommissionRateDto[]> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<CompanyCommissionRateDto[]> = await client.get<CompanyCommissionRateDto[]>(`api/CompanyCommissionRate/company/${companyId}`);
        return res.data;
    };

    createCommissionRate = async (rate: CompanyCommissionRateDto): Promise<CompanyCommissionRateDto> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<CompanyCommissionRateDto> = await client.post(`api/CompanyCommissionRate`, rate);
        return res.data;
    };

    updateCommissionRate = async (rate: CompanyCommissionRateDto): Promise<CompanyCommissionRateDto> => {
        client.setBaseURLForService(carrierBaseKey);
        const res: AxiosResponse<CompanyCommissionRateDto> = await client.put(`api/CompanyCommissionRate/${rate.id}`, rate);
        return res.data;
    };

    deleteCommissionRate = async (id: string): Promise<void> => {
        client.setBaseURLForService(carrierBaseKey);
        await client.delete(`api/CompanyCommissionRate/${id}`);
    };

getATMSRatingCompanies = async (): Promise<AdvPlusRatingCompanyDto[]> => {
        client.setBaseURLForService(retentionArrayBaseKey);
        const res = await client.get<AdvPlusRatingCompanyDto[]>(`RetentionArray/GetATMSRatingCompanies`);
        return res.data;
    };

    getRetentionRates = async (retentionArrayType: string, parentAgency: string): Promise<CompanyRetentionRateDto[]> => {
        client.setBaseURLForService(retentionArrayBaseKey);
        const query = `retentionArrayTypeId=${encodeURIComponent(retentionArrayType)}&parentAgencyId=${encodeURIComponent(parentAgency)}`;
        const res = await client.get<CompanyRetentionRateDto[]>(`RetentionArray/GetAllRetentionArray?${query}`);
        return res.data;
    };

    createRetentionRate = async (request: CreateCompanyRetentionRateDto): Promise<CompanyRetentionRateDto> => {
        client.setBaseURLForService(retentionArrayBaseKey);
        const res = await client.post<CreateCompanyRetentionRateDto, AxiosResponse<CompanyRetentionRateDto>>('RetentionArray/CreateRetentionArray', request);
        return res.data;
    };

    updateRetentionRate = async (rate: UpdateCompanyRetentionRateDto): Promise<CompanyRetentionRateDto> => {
        client.setBaseURLForService(retentionArrayBaseKey);
        const res = await client.put<UpdateCompanyRetentionRateDto, AxiosResponse<CompanyRetentionRateDto>>(`RetentionArray/UpdateRetentionArray?id=${rate.id}`, rate);
        return res.data;
    };

    deleteRetentionRate = async (id: string): Promise<void> => {
        client.setBaseURLForService(retentionArrayBaseKey);
        const query = `id=${encodeURIComponent(id)}`
        await client.delete(`RetentionArray/DeleteRetentionArray?${query}`);
    };

    getAgentCodes = async (carrierId: string): Promise<any[]> => {
        client.setBaseURLForService(carrierBaseKey);
        const res = await client.get<any[]>(`api/Company/${carrierId}/agentcodes`);
        return res.data;
    };

    createAgentCode = async (carrierId: string, dto: any): Promise<any> => {
        client.setBaseURLForService(carrierBaseKey);
        const res = await client.post<any>(`api/Company/${carrierId}/agentcodes`, dto);
        return res.data;
    };

    updateAgentCode = async (carrierId: string, id: string, dto: any): Promise<any> => {
        client.setBaseURLForService(carrierBaseKey);
        const res = await client.put<any>(`api/Company/${carrierId}/agentcodes/${id}`, dto);
        return res.data;
    };

    deleteAgentCode = async (carrierId: string, id: string): Promise<void> => {
        client.setBaseURLForService(carrierBaseKey);
        await client.delete(`api/Company/${carrierId}/agentcodes/${id}`);
    };
}
